export default __webpack_public_path__ + "static/route-756b9800abac03fca5131e1d23069b7d.png";